import { createDynamicThunk } from ".";

export const getPermissionListThunk = createDynamicThunk({
  typePrefix: "permissions/getPermissionListThunk",
  useHandleSearch: true,
});

export const addPermissionThunk = createDynamicThunk({
  typePrefix: "permissions/addPermissionThunk",
  endpoint: "/permissions",
  method: "POST",
  refreshList: true,
  listThunk: getPermissionListThunk,
});

export const deletePermissionThunk = createDynamicThunk({
  typePrefix: "/deletePermissionThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getPermissionListThunk,
});
